import React from "react";
import {
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";
import { useState } from "react";
import { Auth } from "aws-amplify";
import awsconfig from "../../aws-exports";
import Amplify from "@aws-amplify/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { useHistory, withRouter } from "react-router-dom";
import LoadingScreen from "src/Shared/LoadingScreen";
Amplify.configure(awsconfig);

const useStyles = makeStyles({
  img: {
    width: "100%",
    height: "100vh",
  },
  form: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  input: {
    marginTop: "30px",
    width: "100%",
  },
  button: {
    width: "100%",
    marginTop: "30px",
    backgroundColor: "#5555b2",
    color: "white",
    fontWeight: "500",
    height: "50px",
  },
  textBox: {
    textAlign: "center",
    fontSize: "40px",
    height: "30vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const initialFormState = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};

const ResetPassword = () => {
  const [formState, updateFormState] = useState(initialFormState);
  const [snackbarMsg, setSnackbarMsg] = useState({
    open: formState,
    message: "",
    severity: "",
  });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState({
    oPass: false,
    pass: false,
    cPass: false,
  });
  const [isValid, setIsValid] = useState({
    oldPassword: {
      valid: true,
      error: "",
    },
    newPassword: {
      valid: true,
      error: "",
    },
    confirmPassword: {
      valid: true,
      error: "",
    },
  });
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const classes = useStyles();
  const isValidHanlder = (name, value) => {
    switch (name) {
      case "oldPassword":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            oldPassword: { valid: false, error: "Invalid Old Password!" },
          });
        } else {
          setIsValid({ ...isValid, oldPassword: { valid: true, error: "" } });
        }
        break;
      case "newPassword":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            newPassword: { valid: false, error: "Invalid Password!" },
          });
        } else if (value.length < 8) {
          setIsValid({
            ...isValid,
            newPassword: {
              valid: false,
              error: "Password must be 8 character long!",
            },
          });
        } else {
          setIsValid({ ...isValid, newPassword: { valid: true, error: "" } });
        }
        break;
      case "confirmPassword":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            confirmPassword: { valid: false, error: "Invalid Password!" },
          });
        } else if (value !== formState.newPassword) {
          setIsValid({
            ...isValid,
            confirmPassword: {
              valid: false,
              error: "Password should be same!",
            },
          });
        } else {
          setIsValid({
            ...isValid,
            confirmPassword: { valid: true, error: "" },
          });
        }
        break;
      default:
        return;
    }
  };
  function onChange(e) {
    e.preventDefault();
    const { name, value } = e.target;
    isValidHanlder(name, value);
    updateFormState(() => ({
      ...formState,
      [name]: value,
    }));
  }

  const snackCloseHandler = () => {
    setSnackbarMsg({ open: false, message: "", severity: "" });
  };

  const checkValid = () => {
    if (
      formState.oldPassword.length < 1 ||
      formState.newPassword.length < 1 ||
      formState.confirmPassword.length < 1 ||
      !isValid.oldPassword.valid ||
      !isValid.newPassword.valid ||
      !isValid.confirmPassword.valid
    ) {
      return false;
    } else {
      return true;
    }
  };

  function resetPass(e) {
    e.preventDefault();
    const { newPassword, oldPassword } = formState;
    if (checkValid().valueOf(true)) {
      setLoading(true);
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return Auth.changePassword(user, oldPassword, newPassword);
        })
        .then((data) => {
          setSnackbarMsg({
            open: true,
            message: "Password reset successfully",
            severity: "success",
          });
        })
        .catch((err) => {
          if (err.message === "Incorrect username or password.") {
            setSnackbarMsg({
              open: true,
              message: "Incorrect old password.",
              severity: "error",
            });
            return;
          }
          setSnackbarMsg({
            open: true,
            message: err.message,
            severity: "error",
          });
        })
        .finally(() => setLoading(false));
    } else {
      setSnackbarMsg({
        open: true,
        message: "Invalid Password!",
        severity: "error",
      });
    }
  }

  return (
    <>
      {loading && <LoadingScreen loading={loading} />}

      <Grid container justify="center">
        <Grid item xs={12} sm={6} md={4}>
          <Typography className={classes.textBox}>Reset Password!</Typography>
          <form
            onSubmit={resetPass}
            className={classes.form}
            noValidate
            autoComplete="off"
          >
            <TextField
              className={classes.input}
              label="Old Password"
              type={showPass.oPass ? "text" : "password"}
              name="oldPassword"
              onChange={onChange}
              variant="outlined"
              required
              autoComplete="off"
              fullWidth={true}
              inputProps={{
                "aria-label": "oldPasswordInput",
              }}
              error={!isValid.oldPassword.valid}
              helperText={
                !isValid.oldPassword.valid && isValid.oldPassword.error
              }
              InputProps={{
                endAdornment: formState.oldPassword.length > 0 && (
                  <InputAdornment classes={classes.inputIcon} position="end">
                    {!showPass.oPass ? (
                      <VisibilityOutlined
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setShowPass({ ...showPass, oPass: true })
                        }
                      />
                    ) : (
                      <VisibilityOffOutlined
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setShowPass({ ...showPass, oPass: false })
                        }
                      />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              className={classes.input}
              label="New Password"
              type={showPass.pass ? "text" : "password"}
              name="newPassword"
              onChange={onChange}
              variant="outlined"
              required
              autoComplete="off"
              fullWidth={true}
              inputProps={{
                "aria-label": "newPasswordInput",
              }}
              error={!isValid.newPassword.valid}
              helperText={
                !isValid.newPassword.valid && isValid.newPassword.error
              }
              InputProps={{
                endAdornment: formState.newPassword.length > 0 && (
                  <InputAdornment classes={classes.inputIcon} position="end">
                    {!showPass.pass ? (
                      <VisibilityOutlined
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPass({ ...showPass, pass: true })}
                      />
                    ) : (
                      <VisibilityOffOutlined
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setShowPass({ ...showPass, pass: false })
                        }
                      />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              className={classes.input}
              label="Confirm Password"
              type={showPass.cPass ? "text" : "password"}
              name="confirmPassword"
              onChange={onChange}
              variant="outlined"
              required
              autoComplete="off"
              fullWidth={true}
              inputProps={{
                "aria-label": "confirmPasswordInput",
              }}
              error={!isValid.confirmPassword.valid}
              helperText={
                !isValid.confirmPassword.valid && isValid.confirmPassword.error
              }
              InputProps={{
                endAdornment: formState.confirmPassword.length > 0 && (
                  <InputAdornment classes={classes.inputIcon} position="end">
                    {!showPass.cPass ? (
                      <VisibilityOutlined
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setShowPass({ ...showPass, cPass: true })
                        }
                      />
                    ) : (
                      <VisibilityOffOutlined
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setShowPass({ ...showPass, cPass: false })
                        }
                      />
                    )}
                  </InputAdornment>
                ),
              }}
            />

            <Button
              data-testid="reset_pass_btn"
              className={classes.button}
              variant="contained"
              color="primary"
              type="submit"
            >
              Submit
            </Button>

            <Snackbar
              open={snackbarMsg.open}
              autoHideDuration={6000}
              onClose={snackCloseHandler}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <Alert
                onClose={snackCloseHandler}
                severity={snackbarMsg.severity}
              >
                {snackbarMsg.message}
              </Alert>
            </Snackbar>
          </form>
        </Grid>
      </Grid>
    </>
  );
};

export default withRouter(ResetPassword);
